<template>
  <div class="search-results-article">
    <div class="results">
      <SearchArticleList
        :article-list="results"
        :fallback="$production.toUpperCase() !== 'READ'"
        show-advertisement
      >
        <template #info="{ article: articleItem }">
          <span class="date" v-html="articleItem.published_at.split(' ')[0]" />
          <span class="author" v-html="' ‧ ' + articleItem.author" />
        </template>
      </SearchArticleList>
    </div>
    <SearchNoResultsText :results="results" />
  </div>
</template>

<script>
import SearchNoResultsText from '@/components/search/SearchNoResultsText'
import SearchArticleList from '@/components/search/SearchArticleList'

export default {
  name: 'SearchResultsArticle',
  components: {
    SearchNoResultsText,
    SearchArticleList
  },
  directives: {},
  props: {},
  data() {
    return {}
  },
  computed: {
    results() {
      const matchedObj = this.$store.getters.getSearchResults.find(searchObj => searchObj['article'])
      return (matchedObj && matchedObj.article) ? matchedObj.article : []
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>
